import { render, staticRenderFns } from "./BackupsTable.vue?vue&type=template&id=1b6b7f56&scoped=true"
import script from "./BackupsTable.vue?vue&type=script&lang=js"
export * from "./BackupsTable.vue?vue&type=script&lang=js"
import style0 from "./BackupsTable.vue?vue&type=style&index=0&id=1b6b7f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b7f56",
  null
  
)

export default component.exports